module.exports = __webpack_public_path__ + "static/media/am5.ce06cbd4.webp";